export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message?: string,
    /** Full parsed error body — e.g. the conflict-gate report on 409s. */
    public readonly body?: unknown,
  ) {
    super(message ?? code);
  }
}

